<template>
    <v-card class="elevation-1">
        <v-card-text>
            <v-layout align-center justify-center v-if="view=='student'">
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-layout wrap>
                        <v-flex style="font-size: 40px;color:#3b5998;border-bottom: 1px solid #3b5998;">
                            <label class="hideInMobile">{{exercise.name}}</label>
                            <div style="float: right;position: relative;width: 120px;color: red;font-size: 20px;font-weight: bold;line-height: 60px">
                                {{remainTime}}
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap  class="hideInMobile">
                        <v-flex xs12 sm6 md6 lg6 xl6>
                            <label class="label">{{$t('lang.exercise.dueDate')}}:</label>
                            {{exercise.dueDate | formatDate}}
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 xl6>
                            <label class="label">{{$t('lang.exercise.questionTime')}}:</label>
                            {{exercise.questionTime}}
                        </v-flex>
                    </v-layout>
                    <!--v-layout>
                        <v-flex xs12 sm6 md6 lg6 xl6>
                            <label class="label">{{$t('lang.exercise.subject')}}:</label>
                            {{exercise.subject}}
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 xl6>
                            <label class="label">{{$t('lang.exercise.markScale')}}:</label>
                            {{exercise.markScale}}
                        </v-flex>
                    </v-layout-->
                    <v-layout class="hideInMobile">
                        <v-flex xs12 sm6 md6 lg6 xl6>
                            <label class="label">{{$t('lang.exercise.numberOfQuiz')}}:</label>
                            {{exercise.numberOfQuiz}}
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6 xl6>
                            <label class="label">Hướng dẫn làm bài: </label>
                            {{exercise.guideline}}
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout v-else>
                <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 10px; margin:10px;border: 1px solid #9E9E9E;">
                    <v-layout wrap>
                        <v-flex xs4 sm4 md4 lg4 xl4>
                            <label class="label">{{$t('lang.exercise.student')}}:</label>
                            {{answer.userName}}
                        </v-flex>
                        <v-flex xs4 sm4 md4 lg4 xl4>
                            <label class="label">{{$t('lang.exercise.endTime')}}:</label>
                            {{answer.endTime | formatDateTime}}
                        </v-flex>
                        <v-flex xs4 sm4 md4 lg4 xl4>
                            <label class="label">Thời gian làm bài:</label>
                            {{calculateWorkTime()}}
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout style="background-color: white" wrap>
                <v-flex
                        xs12
                        sm12
                        md8
                        lg8
                        xl8
                        style="border:1px solid gray; border-radius:5px;max-height: 800px;overflow: scroll"
                        class="view_exercise"
                >
                    <table class="lstTable" v-if="attachs.length>0">
                        <tr class="yoprimary">
                            <td colspan="2">Danh sách tệp câu hỏi</td>
                        </tr>
                        <tr v-for="att in attachs" :key="att+att.attachId">
                            <td style="text-align: left"><a
                                    @click="viewAtt(att)">{{att.fileName}}</a>
                            </td>
                            <td style="text-align: center" width="20%"><a
                                    @click="downloadAtt(att)">
                                <v-icon>cloud_download</v-icon>
                            </a></td>
                        </tr>
                    </table>
                    <table class="lstTable"
                           v-if="(exercise.answerAttachId != null || exercise.source == 1 )&& ((exercise.permission==2 && (answer.status == 2 || answer.status == 3 || answer.status==4))|| view=='teacher')">
                        <tr class="yoprimary">
                            <td v-if="exercise.source==1">Lời giải chi tiết</td>
                            <td v-else colspan="2">Lời giải chi tiết</td>
                        </tr>
                        <tr>
                            <td style="text-align: left"><a
                                    @click="viewAnswerAtt(exercise.answerAttachId,exercise.answerAttachType)">Lời
                                giải chi
                                tiết</a>
                            </td>
                            <td style="text-align: center" width="20%" v-if="exercise.source==0"><a
                                    @click="downloadAnswerAtt(att)">
                                <v-icon>cloud_download</v-icon>
                            </a></td>
                        </tr>
                    </table>

                    <file-view
                            :editable="false"
                            accept=".pdf, image/*"
                            :attachId="attachId"
                            :attachType="attachType"
                    />
                    <yolearn-question :exam-id="examId" :type="yolearnView" id="viewYoclassQuestion" ref="yolearn"/>
                </v-flex>
                <v-flex
                        xs12
                        sm12
                        md4
                        lg4
                        xl4
                        style="border:1px solid gray; border-radius:5px;padding:10px;max-height: 800px;overflow: scroll"
                        class="do_exercise"
                >

                    <div v-if="answer.status == 0 || answer.status == 1">
                        <div style="text-align: center">
                            <div style="display: inline-block;margin-top:10px"
                                 v-for="item in parseInt(exercise.numberOfQuiz)">
                                <a v-if="answerOptions[item-1] == null || answerOptions[item-1] == ''"
                                   class="quizQuestion"
                                   :id="'anchor'+(item-1)"
                                   :href="'#question'+(item-1)"

                                >{{item}}</a>
                                <a v-else
                                   class="quizQuestion yoprimary"
                                   :id="'anchor'+(item-1)"
                                   :href="'#question'+(item-1)"
                                >{{item}}:{{answerOptions[item-1]}}</a>

                            </div>
                        </div>

                        <div :id="'question'+(item-1)"
                             v-for="item in parseInt(exercise.numberOfQuiz)">
                            <!--div class="answerHeader">Câu {{ item}}</div-->
                            <v-layout style="line-height: 30px">
                                <v-flex xs3 sm3 md3 lg3 xl3>Câu {{ item}}:</v-flex>
                                <v-flex xs2 sm2 md2 lg2 xl2>
                                    <label>A </label>
                                    <input type="radio" v-model="answerOptions[item-1]" label="A" value="A"
                                           :disabled="editable"/>
                                </v-flex>
                                <v-flex xs2 sm2 md2 lg2 xl2>
                                    <label>B </label>
                                    <input type="radio" v-model="answerOptions[item-1]" label="B" value="B"
                                           :disabled="editable"/>
                                </v-flex>
                                <v-flex xs2 sm2 md2 lg2 xl2>
                                    <label>C </label>
                                    <input type="radio" v-model="answerOptions[item-1]" label="C" value="C"
                                           :disabled="editable"/>
                                </v-flex>
                                <v-flex xs2 sm2 md2 lg2 xl2>
                                    <label>D </label>
                                    <input type="radio" v-model="answerOptions[item-1]" label="D" value="D"
                                           :disabled="editable"/>
                                </v-flex>
                            </v-layout>

                        </div>
                    </div>
                    <div v-else>
                        <div>Số câu đúng: {{numberOfRight}}</div>
                        <div>Số câu sai: {{numberOfWrong}}</div>
                        <div>Số câu chưa làm: {{numberOfUnComplete}}</div>
                        <div>Cho phép:
                            <label v-if="exercise.permission==0">Chỉ xem điểm</label>
                            <label v-else-if="exercise.permission==1">Xem đáp án</label>
                            <label v-if="exercise.permission==2">Xem đáp án và lời giải chi tiết</label>
                        </div>
                        <table style="margin-top: 10px; margin-bottom: 10px; width: 100%;border-collapse: collapse">
                            <tr style="color:#2E94C4;border-bottom: 1px solid #e4e4e4">
                                <th width="25%">Câu</th>
                                <th width="25%">HS Chọn</th>
                                <th width="25%"
                                    v-if="exercise.permission==2|| exercise.permission==1 || view=='teacher'">
                                    Đáp án
                                </th>
                                <th width="25%"
                                    v-if="exercise.permission==2|| exercise.permission==1 || view=='teacher'"></th>
                            </tr>
                            <tr v-for="item in parseInt(exercise.numberOfQuiz)"
                                style="border-bottom: 1px solid #e4e4e4">
                                <td style="text-align: center">{{item}}</td>
                                <td style="text-align: center"
                                    v-if="answerOptions != null && answerOptions.length>=item">
                                    {{answerOptions[item-1]}}
                                </td>
                                <td style="text-align: center" v-else></td>
                                <td style="text-align: center"
                                    v-if="exercise.permission==2|| exercise.permission==1|| view=='teacher'">
                                    {{rightAnswer[item-1].answer}}
                                </td>
                                <td style="text-align: center"
                                    v-if="exercise.permission==2|| exercise.permission==1|| view=='teacher'">
                                    <v-icon v-if="answerOptions != null && answerOptions[item-1] == rightAnswer[item-1].answer"
                                            class="primaryColor">check
                                    </v-icon>
                                    <v-icon v-else color="red">clear</v-icon>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-if="answer.status == 2 || answer.status == 3 || answer.status == 4">
                        <v-form @keyup.enter.native="onSave">
                            <v-text-field append-icon="format_list_numbered" v-validate="'required|decimal:2'"
                                          :label="$t('lang.exercise.mark')"
                                          v-model="answer.mark"
                                          name="mark"
                                          :readonly="editCommentStatus"
                                          :data-vv-as="$t('lang.exercise.mark')"
                                          :error-messages="errors.first('mark')"/>
                            <label class="label">{{$t('lang.exercise.comment')}}</label>
                            <v-text-field append-icon="thumb_up" v-validate="'required'"
                                          :label="$t('lang.exercise.teacherComment')"
                                          v-model="answer.teacherComment"
                                          name="teacherComment"
                                          :readonly="editCommentStatus"
                                          list="commentSuggest"
                                          :data-vv-as="$t('lang.exercise.teacherComment')"
                                          :error-messages="errors.first('teacherComment')"/>
                            <datalist id="commentSuggest">
                                <option value="Tốt"/>
                                <option value="Rất tốt"/>
                            </datalist>
                            <!--v-text-field append-icon="trending_down" v-validate="'required'"
                                          :label="$t('lang.exercise.teacherCommentImprove')"
                                          v-model="answer.teacherCommentImprove"
                                          name="teacherCommentImprove"
                                          :readonly="editCommentStatus"
                                          list="attitudeCommentSuggest"
                                          :data-vv-as="$t('lang.exercise.teacherCommentImprove')"
                                          :error-messages="errors.first('teacherCommentImprove')"/>
                            <datalist id="attitudeCommentSuggest">
                                <option value="Rất nghiêm túc"/>
                                <option value="Nghiêm túc"/>
                                <option value="Thiếu tích cực"/>
                            </datalist-->
                        </v-form>
                    </div>
                    <div>
                        <v-spacer></v-spacer>
                        <v-btn color="cancel" @click="cancel">
                            {{ $t('lang.common.back') }}
                        </v-btn>
                        <v-btn color="primary" dark @click="onSave"
                               v-if="user.role == 2 && (answer.status == 1 || answer.status == 0)">
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="onSend"
                               v-if="user.role == 2 && (answer.status == 1 || answer.status == 0) && !isExpire(exercise.dueDate)">
                            {{$t('lang.class.sendExercise')}}
                        </v-btn>
                        <v-btn class="primary" dark @click="onMark"
                               v-if="user.role == 4 && (answer.status == 2 || answer.status == 3)">
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="onSendMark"
                               v-if="user.role == 4 && (answer.status == 2 || answer.status == 3)">
                            {{$t('lang.exercise.returnExercise')}}
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import {message} from "../../services";
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios";
    import IUpload from "../../components/form/Upload";
    import pdf from "vue-pdf";
    import FileView from "./fileView";
    import moment from "moment";
    import YolearnQuestion from "./YolearnQuestion";

    export default {
        name: "do-quiz",
        components: {
            YolearnQuestion,
            pdf,
            IUpload,
            IDatepicker,
            FileView
        },

        props: {
            exerciseType: {
                type: Number,
                default: 6
            },
            view: {
                type: String,
                default: () => {
                    return "student";
                }
            },

            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            },

            studentId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            }
        },
        data() {
            return {
                uploadAnswer: null,
                clazz: {},
                user: {},
                interval: null,
                remainTime: "",
                hardLevelItems: [1, 2, 3, 4, 5],
                answerOptions: [],
                rightAnswer: [],
                accept: ".pdf, image/*",
                numberOfQuiz: 0,
                fileName: "",
                numPages: 0,
                currentPage: 1,
                examId: null,
                attachPath: "",
                fileType: "",
                answer: {},
                exercise: {},
                subjects: [],
                grades: [],
                attachs: [],
                attachId: null,
                attachType: null,
                yolearnView: "exam",
            };
        },

        watch: {},

        created() {
            this.user = this.$store.state.auth.user;
            ////console.log(this.question);
            if (this.question != null) {
                this.exercise.questionId = this.question.questionId;
                this.exercise.name = this.question.name;
                this.exercise.guideline = this.question.guideline;
                this.exercise.subject = this.question.subject;
                this.exercise.questionTime = this.question.questionTime;
                this.exercise.numberOfQuiz = this.question.numberOfQuiz;
                this.exercise.dueDate = this.question.dueDate;
                this.exercise.effectiveDate = this.question.effectiveDate;
                this.exercise.markScale = this.question.markScale;
                this.exercise.question = this.question.question;
                this.exercise.permission = this.question.permission;
                this.exercise.source = this.question.source;
                this.exercise.examId = this.question.examId;
                this.examId = this.question.examId;
                this.exercise.attachId = this.question.attachId;
                this.exercise.attachType = this.question.attachType;
                this.exercise.answerAttachId = this.question.answerAttachId;
                this.exercise.answerAttachType = this.question.answerAttachType;
                ////console.log(this.exercise);
                if (this.question.attachs == undefined || this.question.attachs == null) {
                    this.attachs = [];
                } else {
                    this.attachs = JSON.parse(this.question.attachs);
                    if (this.attachs.length > 0) {
                        this.attachId = this.attachs[0].attachId;
                        this.attachType = this.attachs[0].type;
                    }
                }

                this.answerOptions = new Array(this.exercise.numberOfQuiz);
                this.rightAnswer = JSON.parse(this.question.question);

                if (this.question.answer != undefined && this.question.answer != null) {
                    if (this.question.answer.answer != undefined && this.question.answer.answer != null) {
                        this.answerOptions = JSON.parse(this.question.answer.answer);
                    }
                    if (this.question.answer.rightAnswer != undefined && this.question.answer.rightAnswer != null) {
                        this.rightAnswer = JSON.parse(this.question.answer.rightAnswer);
                    }
                    this.answer = this.question.answer;
                    //console.log(this.answer);
                    //console.log(this.answerOptions);
                    if (this.user.role == 2 && (this.answer.status == 1 || this.answer.status == 0)) {
                        this.interval = setInterval(this.calculateTime, 1000);
                    }
                } else {
                    this.answer = {};
                }
                if (this.studentId != null) {
                    let answer = {
                        'exerciseId': this.question.questionId,
                        'exerciseType': this.exerciseType,
                        'userId': this.studentId
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getStudentAnswer", answer).then(
                        data => {
                            this.answer = data;
                            this.answerOptions = JSON.parse(data.answer);
                            if (data.rightAnswer != undefined && data.rightAnswer != null && data.rightAnswer != "") {
                                this.rightAnswer = JSON.parse(data.rightAnswer);
                            }
                        },
                        error => {

                        }
                    )
                }
            } /*else {
                this.exercise.questionId = null;
                this.exercise.name = "";
                this.exercise.subject = "";
                this.exercise.questionTime = 90;
                this.numberOfQuiz = 0;
                this.exercise.dueDate = null;
                this.exercise.effectiveDate = null;
                this.exercise.markScale = 10;
                this.exercise.question = null;
                this.exercise.attachId = null;
                this.exercise.attachType = null;
                this.childExercise = [];
            }*/
        },

        computed: {
            numberOfRight() {
                let count = 0;
                try {
                    if (this.answerOptions != null) {
                        for (let i = 0; i < this.exercise.numberOfQuiz; i++) {
                            if (this.answerOptions[i] == this.rightAnswer[i].answer) {
                                count++;
                            }
                        }
                    }
                } catch (e) {
                    //console.log(e);
                }
                return count;
            },
            numberOfWrong() {
                let count = 0;
                try {
                    if (this.answerOptions != null) {
                        for (let i = 0; i < this.exercise.numberOfQuiz; i++) {
                            if (this.answerOptions[i] != this.rightAnswer[i].answer) {
                                count++;
                            }
                        }
                    } else {
                        count = this.exercise.numberOfQuiz;
                    }
                } catch (e) {
                    //console.log(e);
                }
                return count;

            },
            numberOfUnComplete() {
                let count = 0;
                if (this.answerOptions != null) {
                    for (let i = 0; i < this.answerOptions.length; i++) {
                        if (this.answerOptions[i] == null || this.answerOptions[i].trim() == "") {
                            count++;
                        }
                    }
                } else {
                    count = this.exercise.numberOfQuiz;
                }
                return count;

            },

            editable: function () {
                if (this.answer == null) {

                }
                if (this.view != "student") {
                    return true;
                } else if (this.answer.status == undefined || this.answer.status == null || this.answer.status == 0 || this.answer.status == 1) {
                    return false;
                } else {
                    return true;
                }
            },

            editCommentStatus: function () {
                if (this.view == "student") {
                    return true;
                } else if (this.answer.status == 2 || this.answer.status == 3) {
                    return false;
                } else {
                    return true;
                }
            },

            duration() {
                //console.log()
            }

        },

        methods: {
            calculateTime: function () {
                if (this.answer.status >= 2) {
                    this.remainTime = "Đã kết thúc";
                } else {
                    if (this.question.questionTime == null || this.question.questionTime == "") {
                        this.remainTime = "";
                    } else {
                        let now = new Date();
                        let start = new Date(this.answer.startTime);
                        let questionTime = this.question.questionTime * 60;
                        let duration = questionTime - parseInt((now.getTime() - start.getTime()) / 1000);
                        if (duration <= 0) {
                            if(!this.isExpire(this.exercise.dueDate)) {
                                alert("Bạn đã hết giờ làm bài, nộp bài ngay bây giờ");
                                this.autoSend();
                            }
                            clearInterval(this.interval);
                            this.interval = null;
                        }
                        let second = duration % 60;
                        duration = parseInt(duration / 60);
                        let minutes = duration % 60; //minutes instead of asMinutes
                        duration = parseInt(duration / 60);
                        let hours = duration % 24; //hours instead of asHours
                        this.remainTime = hours + "h:" + minutes + "m:" + second + "s";
                    }
                }
            },

            calculateWorkTime: function () {
                if (this.answer.status < 2) {
                    return "";
                } else {
                    if (this.answer.startTime == null || this.answer.endTime == null) {
                        return "";
                    } else {
                        let start = new Date(this.answer.startTime);
                        let end = new Date(this.answer.endTime);
                        let duration = parseInt((end.getTime() - start.getTime()) / 1000);
                        let second = duration % 60;
                        duration = parseInt(duration / 60);
                        let minutes = duration % 60; //minutes instead of asMinutes
                        duration = parseInt(duration / 60);
                        let hours = duration % 24; //hours instead of asHours
                        let str = "";
                        if (hours > 0) {
                            str = hours + "h:";
                        }
                        str += minutes + "m:" + second + "s";
                        return str;
                    }
                }
            },

            isExpire(time){
                ////console.log(time);
                time = time +"T23:59:59";
                let now = new Date();
                let t = new Date(time);
                if (t.getTime() < now.getTime()) {
                    return true;
                } else {
                    return false;
                }

            },

            save(status,noValidate) {
                if(noValidate == undefined || noValidate == false) {
                    let validate = true;
                    ////console.log(this.answerOptions);
                    for (let i = 0; i < this.answerOptions.length; i++) {
                        if (this.answerOptions[i] == null || this.answerOptions[i] == "") {
                            validate = false;
                            break;
                        }
                    }
                    ////console.log(validate);
                    if (!validate) {
                        if (!confirm("Bạn chưa trả lời đủ câu hỏi, bạn có muốn tiếp tục?")) {
                            return;
                        }
                    }

                    if (status == 2) {
                        if (!confirm("Bạn có chắc chắn muốn nộp bài không?")) {
                            return;
                        }
                    }
                }

                let answerExercise = {
                    exerciseId: this.exercise.questionId,
                    exerciseType: this.exerciseType,
                    answer: JSON.stringify(this.answerOptions)
                };
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/completeExercise?status=" + status + "&classId=" + this.classId,
                        answerExercise
                    )
                    .then(
                        data => {
                            if (data.success) {
                                if (status == 2) {
                                    message.success("Nộp bài thành công");
                                    this.answer.status = 2;
                                    this.$emit("reload");
                                    //this.cancel();
                                } else {
                                    message.success(this.$t("lang.common.save_success"));
                                }
                                //this.cancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
            },

            onSave: function () {
                if (this.user.role == 2 && (this.answer.status == 1 || this.answer.status == 0)) {
                    this.save(1);
                } else if (this.user.role == 1 && (this.answer.status == 2 || this.answer.status == 3)) {
                    this.onMark();
                } else {
                    this.cancel();
                }
            },

            onSend() {
                this.save(2);
                clearInterval(this.interval);
            },

            autoSend(){
                this.save(2,true);
            },

            onMark() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    if (this.answer.mark > this.exercise.markScale) {
                        message.error("Điểm đã nhập không được lớn hơn thang điểm");
                        return;
                    }
                    let answerExercise = {
                        'exerciseId': this.exercise.questionId,
                        'exerciseType': this.exerciseType,
                        'userId': this.answer.userId,
                        'mark': this.answer.mark,
                        'teacherComment': this.answer.teacherComment,
                        'teacherCommentImprove': this.answer.teacherCommentImprove
                    };
                    axios.post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/saveExerciseMark",
                        answerExercise
                    )
                        .then(
                            data => {
                                if (data.success) {
                                    message.success(this.$t("lang.common.save_success"));
                                    this.cancel();
                                } else {
                                    message.error(this.$t(data.description));
                                }
                            },
                            error => {
                                //console.log(error);
                            }
                        );
                });
            },

            onSendMark() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    if (this.answer.mark > this.exercise.markScale) {
                        message.error("Điểm đã nhập không được lớn hơn thang điểm");
                        return;
                    }
                    let answerExercise = {
                        'exerciseId': this.exercise.questionId,
                        'exerciseType': this.exerciseType,
                        'userId': this.answer.userId,
                        'mark': this.answer.mark,
                        'teacherComment': this.answer.teacherComment,
                        'teacherCommentImprove': this.answer.teacherCommentImprove
                    };
                    axios.post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/sendExerciseMark",
                        answerExercise
                    )
                        .then(
                            data => {
                                if (data.success) {
                                    message.success(this.$t("lang.common.save_success"));
                                    this.cancel();
                                } else {
                                    message.error(this.$t(data.description));
                                }
                            },
                            error => {
                                //console.log(error);
                            }
                        );
                });
            },

            viewAtt: function (att) {
                this.attachType = att.type;
                this.attachId = att.attachId;
            },

            viewAnswerAtt: function (attachId, attachType) {
                if (this.exercise.source == 1) {
                    this.yolearnView = "review";
                    this.$nextTick(() => {
                        this.$refs.yolearn.viewAnswerDetail();
                    });
                } else {
                    //console.log(attachId);
                    //console.log(attachType);
                    this.attachId = attachId;
                    this.attachType = attachType;
                }
            },

            downloadAtt: function (att) {
                window.location = process.env.VUE_APP_API_URL + "/download/attach/" + att.attachId;
            },

            downloadAnswerAtt() {
                window.location = process.env.VUE_APP_API_URL + "/download/attach/" + this.exercise.answerAttachId;
            },

            cancel: function () {
                this.$emit("onback");
            },
        },

        beforeDestroy() {
            if (this.interval != null) {
                clearInterval(this.interval);
            }
        }

    };
</script>

